/* global console */

// Search logic is implemented here.

import Vue from "vue";
import $ from "jquery";

import searchPage from "./search-page.js";

console.log("Search page scripts called");

$(() => {
  // Spawn a search page element
  new Vue({
    el: "#search-page",
    data: {},
    // Define the renderer for the main search result component
    render: (cElm) => cElm(searchPage)
  });
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/archive.js